import styled, { css } from "styled-components";
import { FlexColumn, FlexColumnDiv, FlexRow, FlexRowDiv } from "./common.styles";
import { LightText, LighterText, Text } from "./HXDesktopPage.styles";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import { Subtitle } from "./HXDesktopPage.styles";
import { MoreInfo } from "./MoreInfo";
import Circle from "@mui/icons-material/Circle";
const cardStyle = css `
    padding: 40px;
    gap: 24px;
    border-radius: 4px;
    border: 1px solid ${colors.black_12};
    background: ${colors.white_main};
    overflow: hidden;
    overflow-x: auto;
`;
export const HXDesktopChartCard = styled(FlexColumn) `
    ${cardStyle}
    gap: ${(props) => { var _a; return (_a = props.gap) !== null && _a !== void 0 ? _a : 40; }}px;
`;
export const HXDesktopChartTextContainer = styled(FlexRow) `
    justify-content: center;
    align-items: flex-end;
    align-content: flex-end;
    gap: 4px;
`;
export const HXDesktopChartSubtitle = styled(LightText) `
    font-weight: ${fontWeights.SEMI_BOLD};
    text-align: center;
    white-space: pre-wrap;
`;
export const HXDesktopChartMoreInfo = styled(MoreInfo).attrs({ arrow: true, placement: "top" }) `
    position: relative;
    left: ${(props) => { var _a; return (_a = props.left) !== null && _a !== void 0 ? _a : "0px"; }};
    color: ${colors.black_lighter};
`;
export const HXDesktopChartStatText = styled(Text) `
    font-size: ${fontSizes.GIANT};
    text-align: center;
    align-self: stretch;
    white-space: pre-wrap;
`;
export const HXDesktopChartText = styled(LightText) `
    align-self: stretch;
    text-align: center;
    white-space: pre-wrap;
`;
export const AtAGlanceContainer = styled(FlexRow) `
    ${cardStyle}
`;
export const AtAGlanceStatContainer = styled(FlexColumn) `
    gap: 16px;
    flex: 1 0 0;
`;
export const BarGraphStatsContainer = styled(FlexRow) `
    gap: 24px;
`;
export const GraphTitle = styled(Subtitle) `
    font-size: ${fontSizes.LARGE};
`;
export const GraphTitleMoreInfo = styled(HXDesktopChartMoreInfo) `
    width: 24px;
    height: 24px;
`;
export const BarGraphColumnContainer = styled(FlexColumn) `
    flex: 1 0 0;
    gap: 24px;
`;
export const BarGraphTextContainer = styled(FlexColumn) `
    height: 108px;
    min-width: 140px;
    justify-content: space-between;
`;
export const BarGraphTitleContainer = styled(FlexRowDiv) `
    align-items: flex-end;
    align-content: flex-end;
    gap: 4px;
`;
export const BarGraphText = styled(HXDesktopChartSubtitle) `
    text-align: left;
`;
export const BarGraphTotalText = styled(HXDesktopChartStatText) `
    text-align: left;
`;
export const BarGraphColumn = styled.div `
    width: 80px;
    height: ${(props) => props.height}px;
    background-color: ${(props) => props.color};
    margin-top: auto;
`;
export const LegendContainer = styled(FlexRow) `
    gap: 16px;
    margin-left: ${(props) => { var _a; return (_a = props.marginLeft) !== null && _a !== void 0 ? _a : 0; }};
    margin-right: ${(props) => { var _a; return (_a = props.marginRight) !== null && _a !== void 0 ? _a : 0; }};
`;
export const LegendItemContainer = styled(FlexRowDiv) `
    align-items: flex-start;
    gap: 4px;
    flex: 1 0 0;
    justify-content: ${(props) => (props.alignEnd ? "flex-end" : "flex-start")};
`;
export const CircleIcon = styled(Circle) `
    width: 16px;
    height: 16px;
    color: ${(props) => props.color};
`;
export const LegendText = styled(LighterText) `
    white-space: pre-wrap;
`;
export const LoaderContainer = styled(FlexColumn) `
    height: ${(props) => { var _a; return (_a = props.height) !== null && _a !== void 0 ? _a : "auto"; }};
    align-items: center;
    justify-content: center;
`;
export const SingleStatCard = styled(FlexColumnDiv) `
    box-sizing: border-box;
    height: 195px;
    min-width: 285px;
    padding: 40px;
    gap: 24px;
    justify-content: center;
    align-items: center;
    gap: 24px;
    flex: 1 0 0;
    border-radius: 2px;
    border: 1px solid ${colors.black_12};
    background: ${colors.white_main};
`;
